// extracted by mini-css-extract-plugin
module.exports = {"herocontainer":"HeroSection_herocontainer__1kN-6","herosection":"HeroSection_herosection__1IDv_","hero-content":"HeroSection_hero-content__11ak7"};